/* eslint-disable */

import React from 'react';
import { langState } from '../state/activities';
import { useRecoilValue } from 'recoil';
import { default as text } from '../translate/lang.json';

const PageAboutUs = () => {
  const lang = useRecoilValue(langState);
  return (
    <div className="max-w-3xl mx-auto py-8 px-4 space-y-6">
      {/* Header */}
      <h1 className="font-bold text-black-accent text-3xl">{text.about_us_title[lang]}</h1>

      {/* About card */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 space-y-4 text-sm text-gray-700 leading-relaxed">
        <p>{text.about_us_people[lang]}</p>
        <p>{text.about_us_questions[lang]}</p>
        <p>{text.about_us_idea[lang]}</p>
        <p>
          {text.about_us_book[lang]}{' '}
          <a className="text-main-blue font-medium hover:underline" href="https://www.diva-portal.org/smash/get/diva2:1252285/FULLTEXT01.pdf." target="_blank" rel="noopener noreferrer">
            Diva-portal ↗
          </a>
        </p>
      </div>

      {/* Vardagboken link card */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 space-y-3">
        <p className="text-sm text-gray-700 leading-relaxed">{text.about_us_vardagboken[lang]}</p>
        <a
          className="inline-flex items-center gap-2 text-sm font-semibold text-main-blue bg-main-blue/10 px-4 py-2 rounded-lg hover:bg-main-blue/20 transition-colors"
          href="https://vardagboken.everydayanalytics.se"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          Vardagboken
        </a>
        <p className="text-sm text-gray-600 leading-relaxed">{text.about_us_homescreen[lang]}</p>
        <div className="flex flex-wrap gap-3">
          <a
            className="text-xs font-medium text-gray-600 bg-gray-100 px-3 py-1.5 rounded-md hover:bg-gray-200 transition-colors"
            href="https://support.apple.com/sv-se/guide/iphone/iph42ab2f3a7/ios"
            target="_blank"
            rel="noopener noreferrer"
          >
            📱 iOS Guide
          </a>
          <a
            className="text-xs font-medium text-gray-600 bg-gray-100 px-3 py-1.5 rounded-md hover:bg-gray-200 transition-colors"
            href="https://www.androidauthority.com/add-website-android-iphone-home-screen-3181682/#1"
            target="_blank"
            rel="noopener noreferrer"
          >
            🤖 Android Guide
          </a>
        </div>
      </div>

      {/* Videos section */}
      <div>
        <h2 className="font-bold text-black-accent text-2xl mb-4">{text.instructional_videos_title[lang]}</h2>
        <div className="grid grid-cols-1 2xl:grid-cols-2 gap-4">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-3 overflow-hidden">
            <iframe
              className="w-full aspect-video rounded-xl"
              src="https://www.youtube.com/embed/YSywPz9FcKk?si=_bBr28i5uW_5Y5r1"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            />
          </div>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-3 overflow-hidden">
            <iframe
              className="w-full aspect-video rounded-xl"
              src="https://www.youtube.com/embed/yIS30TOcIEw?si=Ib3qCZ53CPDzQxjn"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageAboutUs;
